// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* .btn {\n  background: $secondary-color;\n} */\n.room-container {\n  background-color: #151515;\n  white-space: nowrap;\n}\n.editor-col {\n  padding: 0 !important;\n}\n.code-editor {\n  height: calc(100vh - 50px);\n}\n.input-editor, .output-terminal {\n  height: calc(100vh - 50px);\n}\n.control-bar {\n  height: 50px;\n}\n.control-bar .media-controls {\n    display: inline;\n    color: #ffffff9c;\n  }\n.control-bar .media-controls .icon {\n      width: 25px;\n    }\n\n", ""]);
// Exports
module.exports = exports;
